import React from 'react'
import { Helmet } from 'react-helmet-async'
import BreadcrumbBack from '../../../components/breadcrumb/BreadcrumbBack'
import CustomButton from '../../../components/button/CustomButton'
import Models from '../../../components/models/Models'
import AdminPaymentModesCE from './AdminPaymentModesCE'

export default function AdminPaymentModes() {
    const [open, setOpen] = React.useState(false)
  return (
    <div>
        <Helmet>
                <title>{` Payment Modes   | ${window.location.hostname}`}</title>
              </Helmet>
              <BreadcrumbBack title={`Payment Modes`}>
                <CustomButton
                  onClick={() => setOpen(!open)}
                  title="Create Payment Mode"
                  icon={true}
                  iconName="credit-card"
                />
                
              </BreadcrumbBack>
              <div className='my-3'>

              </div>
               <Models name="Create Payment Mode" isOpen={open} isClose={setOpen}>
                      <AdminPaymentModesCE type="create" open={setOpen} />
                    </Models>
    </div>
  )
}
